import { Pipe, PipeTransform, SecurityContext } from "@angular/core";

const PADDING = "000000";

@Pipe({
    name: 'currencyPipe',
    standalone: false
})
export class CurrencyPipe implements PipeTransform {

    

    private DECIMAL_SEPARATOR: string;
    private THOUSANDS_SEPARATOR: string;
  
    constructor() {
      this.DECIMAL_SEPARATOR = ",";
      this.THOUSANDS_SEPARATOR = "."; 
    }
  
    transform(value: number | string, fractionSize: number = 2): string { //front
        
      let [ integer, fraction = "" ] = (value || "").toString()
        .split('.');
  
      fraction = fractionSize > 0 ? this.DECIMAL_SEPARATOR + (fraction + PADDING).substring(0, fractionSize): "";
  
      integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, this.THOUSANDS_SEPARATOR);
  
      return integer + fraction;
    }
  
    parse(value: string, fractionSize: number = 2): string { //toback
        
      let [ integer, fraction = "" ] = (value || "").split(this.DECIMAL_SEPARATOR);
  
      integer = integer.replace(this.THOUSANDS_SEPARATOR, "");
  
      fraction = parseInt(fraction, 10) > 0 && fractionSize > 0
        ? '.' + (fraction + PADDING).substring(0, fractionSize)
        : "";
  
      return integer + fraction;
    }
}